import { render, staticRenderFns } from "./UsergroupsOptions.vue?vue&type=template&id=06bd1798"
import script from "./UsergroupsOptions.vue?vue&type=script&lang=js"
export * from "./UsergroupsOptions.vue?vue&type=script&lang=js"
import style0 from "./UsergroupsOptions.vue?vue&type=style&index=0&id=06bd1798&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports